export default __webpack_public_path__ + "static/media/pizza.936d638c.png";